export enum TicketTypeEnum {
    REPAIR = 'Repair',
    MAINTENANCE = 'Maintenance',
    INSTALLATION = 'Installation',
    SURVEY = 'Survey',
}
